import React, { useCallback } from 'react';

import { isUserNeedBankAccountNumbers, isUserNeedKyc, useApplicationState } from '@atlas/core';
import { Button } from '@atlas/ui';

import { goToAccountNumbersPage, goToVerificationPage } from 'src/helpers/verification';

const VerificationButton = ({ label = 'go_to_kyc', onClick }) => {
  const { account } = useApplicationState();

  const processVerification = useCallback(() => {
    onClick?.();

    if (isUserNeedKyc(account)) {
      goToVerificationPage();
    } else if (isUserNeedBankAccountNumbers(account)) {
      goToAccountNumbersPage();
    }
  }, [account, onClick]);

  return (
    <Button
      className="kyc-verification__button"
      label={label}
      onClick={processVerification}
      size="big"
      type="primary"
    />
  );
};

export default VerificationButton;
